/**
 * What the WhatsApp-bridge row shows for a bridged group.
 *
 * The api returns the channel with its raw Periskope id (`waGroupId`, e.g.
 * "120363430245648825@g.us") and, separately, the org's WhatsApp groups with
 * their names. The row used to print the id — Nikhil, 2026-09-15: "it should
 * show the name of the group (id is not understandable by user).. also better
 * if it could have a link to the chat from there". The name comes from the
 * candidate whose groupId matches; the id stays available as a tooltip.
 */
import { CHAT_PATH } from '../../Chat/user_chat';

/** The WhatsApp group's name for a bridged channel; the raw id when no candidate names it. */
export const bridged_group_name = (group, candidates) => {
    if (!group || !group.waGroupId) return null;
    const hit = (Array.isArray(candidates) ? candidates : []).find((c) => c && c.groupId === group.waGroupId);
    return (hit && hit.groupName) || group.waGroupId;
};

/** Deep link into the Chat inbox for this channel (the same link web-push and the member list use). */
export const channel_chat_href = (group) => (group && group.id ? `${CHAT_PATH}?channel=${encodeURIComponent(String(group.id))}` : null);
